// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__YoAIc","log":"ModalInventoryLogs_log__2ULbt","date":"ModalInventoryLogs_date__2Y9L7","userName":"ModalInventoryLogs_userName__5MF1o"};